import { useTranslation } from 'react-i18next';
import { BottomLabelChip, BottomRow } from './styles';
import type { ApprovalViewSecurity } from './types';

/** 하단 작성일 / 조회등급 chip 두 개 */
type BottomLabelsProps = {
  authoredAt: string;
  security: ApprovalViewSecurity;
};

/** 조회등급 라벨 */
const SECU_LEVEL_LABEL: Record<ApprovalViewSecurity, string> = {
  1: '전체공개',
  3: '사업부공개',
  5: '부서공개',
  7: '결재라인공개',
  9: '비공개',
};

const formatDate = (iso: string): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const BottomLabels = ({ authoredAt, security }: BottomLabelsProps) => {
  const { t } = useTranslation();

  const dateText = formatDate(authoredAt);
  const securityLabel = SECU_LEVEL_LABEL[security] ?? `${security}`;

  return (
    <BottomRow>
      <BottomLabelChip>
        {t('작성일')}: {dateText}
      </BottomLabelChip>
      <BottomLabelChip>
        {t('조회등급')}: {t(securityLabel)}
      </BottomLabelChip>
    </BottomRow>
  );
};

export default BottomLabels;
